import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const AmountItem = ({ label, value }) => {
  return (
    <div className="flex items-center gap-1 whitespace-nowrap">
      <Typography variant="p" weight="medium" size="small" color="neutral-500">
        {label}
      </Typography>
      <Typography variant="p" weight="medium" size="small" color="neutral-700">
        {mString(value)}
      </Typography>
    </div>
  );
};

export default AmountItem;
